import React from 'react';
import styled from 'styled-components';

interface IToggleProps {
  isActive: boolean;
  onToggle: () => void;
  label?: string;
  children?: React.ReactNode;
}

interface IToggleSwitchProps {
  isActive: boolean;
}

type IToggleCircleProps = IToggleSwitchProps

const Toggler: React.FC<IToggleProps> = (props) => {
  const { isActive, onToggle, label, children } = props;

  return (
    <ToggleContainer onClick={onToggle}>
      <ToggleSwitch isActive={isActive}>
        <ToggleCircle isActive={isActive} />
      </ToggleSwitch>
      {children ? children : label && <ToggleText>{label}</ToggleText>}
    </ToggleContainer>
  );
};

export default Toggler;

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const ToggleSwitch = styled.div<IToggleSwitchProps>`
  width: 36px;
  height: 20px;
  border-radius: 10px;
  background-color: ${({ isActive }) => (isActive ? '#FF7E55' : '#555')};
  position: relative;
  margin-right: 10px;
  transition: background-color 0.3s ease;
`;

const ToggleCircle = styled.div<IToggleCircleProps>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  top: 2px;
  left: ${({ isActive }) => (isActive ? '18px' : '2px')};
  transition: left 0.3s ease;
`;

const ToggleText = styled.span`
  font-family: Nunito Sans;
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  color: #A9A9A9;
`;

